import { createSlice } from "@reduxjs/toolkit";

const productOrderSlice = createSlice({
  name: "productOrder",
  initialState: {
    loading: false,
    data: null,
    error: null,
    productResponse: null,
  },
  reducers: {
    getProductOrderDataRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getProductOrderDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload || null;
    },
    getProductOrderDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createProductOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    createProductOrderSuccess: (state, action) => {
      state.loading = false;
      state.productResponse = action.payload || null;
    },
    createProductOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetProductOrderState: (state) => {
      state.loading = false;
      state.data = null;
      state.productResponse = null;
      state.error = null;
    },
  },
});

export const {
  getProductOrderDataRequest,
  getProductOrderDataSuccess,
  getProductOrderDataFailure,
  createProductOrderRequest,
  createProductOrderSuccess,
  createProductOrderFailure,
  resetProductOrderState,
} = productOrderSlice.actions;

export default productOrderSlice.reducer;
